import { ReactElement } from 'react'
import { InputGroup, Text } from '@raskrask-dk/rr-components'
import CompanyCardPage from '../../companycard'
import { useTranslation } from 'react-i18next'
import { PropsNumberOfPeopleTemplate } from './props'

const NumberOfPeopleTemplate = ({
    currentStep,
    helpers,
    onChangeNumOfP,
    amountOfPeople,
    dataCy,
}: PropsNumberOfPeopleTemplate): ReactElement => {
    const { t } = useTranslation()

    const choosenText = amountOfPeople ? amountOfPeople : ''

    return (
        <CompanyCardPage
            choosenText={[choosenText]}
            dataCy={dataCy}
            onClickNext={helpers.goToNextStep}
            open={currentStep === 3}
            setOpen={() => helpers.setStep(currentStep === 3 ? 7 : 3)}
            title={t('companylead.numberpeople.header')}
        >
            <Text>{t('companylead.numberpeople.text')}</Text>
            <InputGroup
                data-cy="numberofpeople"
                label={t('companylead.numberpeople.placeholder')}
                onChange={(e) => onChangeNumOfP(e)}
                type="text"
                value={amountOfPeople}
            />
        </CompanyCardPage>
    )
}

export default NumberOfPeopleTemplate
